import React from 'react';
import { Plus, Minus, MessageCircle } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = React.useState(null);

  const faqs = [
    {
      question: "What makes your editing retention-optimized?",
      answer: "We use a combination of fast-paced cuts, visual hooks every 3 seconds, dynamic captions, and sound design specifically engineered to keep the viewer's dopamine levels high and prevent scrolling."
    },
    {
      question: "What video formats do you accept?",
      answer: "We accept all major formats (MP4, MOV, etc.). You can upload your raw footage to a shared Google Drive or Dropbox folder, and we'll handle the rest."
    },
    {
      question: "Can you edit for multiple platforms?",
      answer: "Absolutely! We specialize in vertical content for TikTok, Instagram Reels, and YouTube Shorts, but we can also repurpose your content for horizontal platforms."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-brand-dark">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-white mb-4">Frequently Asked <span className="text-brand-magenta">Questions</span></h2>
          <p className="text-gray-400">Everything you need to know about working with ViralVantage Media.</p>
        </div>

        <div className="space-y-4 mb-16">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="border border-brand-magenta/20 rounded-2xl bg-brand-darker overflow-hidden transition-all"
            >
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center text-white hover:bg-white/5 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-bold text-lg">{faq.question}</span>
                {openIndex === index ? <Minus className="text-brand-magenta" /> : <Plus className="text-brand-magenta" />}
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 text-gray-400 leading-relaxed animate-fadeIn">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* DÜZELTİLEN BEYAZ BUTON KISMI BURASI */}
        <div className="bg-brand-darker border border-brand-magenta/20 p-10 rounded-3xl text-center shadow-2xl">
          <h3 className="text-2xl font-bold text-white mb-2">Still Have Questions?</h3>
          <p className="text-gray-400 mb-8">Our team is here to help. Get in touch and we'll answer any questions you have.</p>
          
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-10 py-4 rounded-full font-black text-lg transition-all duration-300 border-2 border-white text-white hover:bg-brand-magenta hover:border-brand-magenta hover:shadow-[0_0_20px_rgba(247,106,195,0.4)] active:scale-95"
          >
            <MessageCircle size={20} />
            Contact Me
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;